/* NADA v2 - interactions additives : hero carrousel, recherche points de vente,
   revelations au scroll, shop-the-ritual. Sans dependance. */
(function () {
  'use strict';
  document.documentElement.classList.add('js');

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function each(list, fn) { Array.prototype.forEach.call(list, fn); }

  /* ---------- 1. Revelations au scroll ---------- */
  function initReveal() {
    var els = document.querySelectorAll('.reveal:not(.is-in)');
    if (!els.length) return;
    if (reduce.matches || !('IntersectionObserver' in window)) {
      each(els, function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      each(entries, function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
    each(els, function (el) { io.observe(el); });
  }

  /* ---------- 2. Hero carrousel ---------- */
  function initSlider(root) {
    if (root.dataset.ready === '1') return;
    root.dataset.ready = '1';

    var slides = root.querySelectorAll('.hslide');
    if (!slides.length) return;
    var dots = root.querySelectorAll('[data-hslider-dot]');
    var prev = root.querySelector('[data-hslider-prev]');
    var next = root.querySelector('[data-hslider-next]');
    var pauseBtn = root.querySelector('[data-hslider-pause]');
    var interval = parseInt(root.dataset.interval, 10) || 7000;
    var wantAuto = root.dataset.autoplay !== 'false' && slides.length > 1;
    var i = 0, timer = null, paused = false;

    function show(n) {
      i = (n + slides.length) % slides.length;
      each(slides, function (s, k) {
        var on = (k === i);
        s.classList.toggle('is-on', on);
        if (on) { s.removeAttribute('aria-hidden'); } else { s.setAttribute('aria-hidden', 'true'); }
      });
      each(dots, function (d, k) {
        d.classList.toggle('is-on', k === i);
        d.setAttribute('aria-selected', k === i ? 'true' : 'false');
      });
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function start() {
      if (!wantAuto || paused || reduce.matches) return;
      stop();
      timer = setInterval(function () { show(i + 1); }, interval);
    }

    show(0);
    start();

    if (prev) prev.addEventListener('click', function () { show(i - 1); start(); });
    if (next) next.addEventListener('click', function () { show(i + 1); start(); });
    each(dots, function (d) {
      d.addEventListener('click', function () { show(parseInt(d.dataset.hsliderDot, 10)); start(); });
    });
    if (pauseBtn) {
      pauseBtn.addEventListener('click', function () {
        paused = !paused;
        pauseBtn.setAttribute('aria-pressed', paused ? 'true' : 'false');
        pauseBtn.setAttribute('aria-label', paused ? 'Reprendre le carrousel' : 'Mettre le carrousel en pause');
        if (paused) { stop(); } else { start(); }
      });
    }

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { stop(); } else { start(); }
    });
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { show(i - 1); start(); }
      if (e.key === 'ArrowRight') { show(i + 1); start(); }
    });

    var x0 = null, y0 = null;
    root.addEventListener('touchstart', function (e) {
      x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; stop();
    }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      var dy = e.changedTouches[0].clientY - y0;
      if (Math.abs(dx) > 46 && Math.abs(dx) > Math.abs(dy) * 1.4) { show(dx < 0 ? i + 1 : i - 1); }
      x0 = null; y0 = null; start();
    }, { passive: true });
  }

  /* ---------- 3. Recherche points de vente ---------- */
  function initStores(root) {
    if (root.dataset.ready === '1') return;
    root.dataset.ready = '1';

    var input = root.querySelector('[data-store-search]');
    var cities = root.querySelectorAll('[data-city]');
    var count = root.querySelector('[data-store-count]');
    var empty = root.querySelector('[data-store-empty]');
    if (!cities.length) return;

    function label() {
      if (!count) return;
      var vis = 0, n = 0;
      each(cities, function (c) {
        if (c.hidden) return;
        vis += 1;
        n += c.querySelectorAll('.scity__item').length;
      });
      count.textContent = vis === 0 ? '' : n + ' points de vente - ' + vis + (vis > 1 ? ' villes' : ' ville');
    }
    function filter(q) {
      q = (q || '').trim().toLowerCase();
      var any = false;
      each(cities, function (c) {
        var hit = !q || (c.dataset.haystack || '').indexOf(q) !== -1;
        c.hidden = !hit;
        if (hit) { any = true; c.open = q ? true : false; }
      });
      if (empty) empty.hidden = any;
      label();
    }

    label();
    if (input) {
      var t;
      input.addEventListener('input', function () {
        clearTimeout(t);
        t = setTimeout(function () { filter(input.value); }, 130);
      });
      input.addEventListener('search', function () { filter(input.value); });
    }
  }

  /* ---------- 4. Shop the ritual ---------- */
  function initShopLook(root) {
    if (root.dataset.ready === '1') return;
    root.dataset.ready = '1';

    var dots = root.querySelectorAll('.shoplook__dot');
    function closeAll(except) {
      each(dots, function (d) {
        if (d === except) return;
        d.setAttribute('aria-expanded', 'false');
        var p = document.getElementById(d.getAttribute('aria-controls'));
        if (p) p.classList.remove('is-on');
      });
    }
    each(dots, function (d) {
      d.addEventListener('click', function (e) {
        e.stopPropagation();
        var open = d.getAttribute('aria-expanded') === 'true';
        closeAll(d);
        d.setAttribute('aria-expanded', open ? 'false' : 'true');
        var p = document.getElementById(d.getAttribute('aria-controls'));
        if (p) p.classList.toggle('is-on', !open);
      });
    });
    document.addEventListener('click', function () { closeAll(null); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(null); });
  }

  /* ---------- Amorcage ---------- */
  function boot() {
    initReveal();
    each(document.querySelectorAll('[data-hslider]'), initSlider);
    each(document.querySelectorAll('[data-stores]'), initStores);
    each(document.querySelectorAll('[data-shoplook]'), initShopLook);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target;
    if (!s) { boot(); return; }
    each(s.querySelectorAll('[data-hslider]'), initSlider);
    each(s.querySelectorAll('[data-stores]'), initStores);
    each(s.querySelectorAll('[data-shoplook]'), initShopLook);
    initReveal();
  });
})();
